import { alpha, Stack } from '@mui/system';

import { theme, Typography } from '@/shared/design-system';

import { ProgressBarContainer, ProgressSegment } from './styled';
import type { ManualAttributionStep } from './types';

const STEP_LABELS: Record<ManualAttributionStep, string> = {
  1: 'Select Introducer',
  2: 'Select User & Attribution Type',
  3: 'Select Fund',
  4: 'Review & Execute',
};

const STEP_DESCRIPTIONS: Record<ManualAttributionStep, string> = {
  1: 'Search for the introducer by email address.',
  2: 'Find the user to attribute. Enter email or paste a new one.',
  3: 'Only active, verified funds are shown. Select the fund for this introduction.',
  4: 'Please review all details carefully before executing.',
};

const TOTAL_STEPS = 4;

interface StepProgressProps {
  currentStep: ManualAttributionStep;
}

export const StepProgress = ({ currentStep }: StepProgressProps) => {
  return (
    <Stack flexDirection="column" gap="8px">
      <Typography variant="body2" color={alpha(theme.colors.text.primary, 0.4)} fontWeight={500}>
        {currentStep}/{TOTAL_STEPS}
        {'  '}
        <Typography variant="body2" as="span" fontWeight={600}>
          {STEP_LABELS[currentStep]}
        </Typography>
      </Typography>
      <ProgressBarContainer>
        {Array.from({ length: TOTAL_STEPS }, (_, i) => (
          <ProgressSegment key={i} active={i < currentStep} />
        ))}
      </ProgressBarContainer>
      <Typography variant="body2" color={alpha(theme.colors.text.primary, 0.6)}>
        {STEP_DESCRIPTIONS[currentStep]}
      </Typography>
    </Stack>
  );
};
